import { inject, Injectable, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isEmpty } from 'lodash';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _ngZone = inject(NgZone);

  private _hasFiltersAppliedSubject$ = new BehaviorSubject<boolean>(
    !isEmpty(this._route.snapshot.queryParams),
  );
  hasFiltersApplied$ = this._hasFiltersAppliedSubject$.asObservable();

  // Update url without refreshing the page
  updateRouterQueryParams(queryParams: unknown): void {
    const params = queryParams as Record<string, unknown>;

    const hasNonPageChanges = Object.keys(params).some((key) => key !== 'page');
    // We force the navigation to page 1 if there are no changes on the 'page' param and the page is not specified either
    const updatedParams =
      hasNonPageChanges && !('page' in params) ? { ...params, page: 1 } : params;

    this._ngZone.run(() => {
      this._router
        .navigate([], {
          relativeTo: this._route,
          queryParams: updatedParams,
          queryParamsHandling: 'merge',
        })
        .then(() => {
          const paramsEmpty =
            isEmpty(this._route.snapshot.queryParams) ||
            !this._route.snapshot.queryParamMap.keys.some(
              (key) => !isEmpty(this._route.snapshot.queryParams[key]),
            ) ||
            (this._route.snapshot.queryParamMap.keys.length === 1 &&
              this._route.snapshot.queryParams.page);

          this._hasFiltersAppliedSubject$.next(!paramsEmpty);
        });
    });
  }
}
